import { BitLength } from '../BitLength.js';
import { BooleanEncoder } from './BooleanEncoder.js';
import { DecodingError } from '../../errors/index.js';
import { IntEncoder } from './IntEncoder.js';
import { PurposeRestrictionVector, PurposeRestriction } from '../../model/index.js';
export class PurposeRestrictionVectorEncoder {
    static encode(prVector) {
        /*                                    */
        let bitString = IntEncoder.encode(prVector.numRestrictions, BitLength.numRestrictions);
        /*                                                                                      */
        if (!prVector.isEmpty()) {
            const nextGvlVendor = (vendorId, lastVendorId) => {
                for (let nextId = vendorId + 1; nextId <= lastVendorId; nextId++) {
                    if (prVector.gvl.vendorIds.has(nextId)) {
                        return nextId;
                    }
                }
                return vendorId;
            };
            /*                            */
            prVector.getRestrictions().forEach((purpRestriction) => {
                /*                                                                 */
                bitString += IntEncoder.encode(purpRestriction.purposeId, BitLength.purposeId);
                bitString += IntEncoder.encode(purpRestriction.restrictionType, BitLength.restrictionType);
                /*                                             */
                const vendors = prVector.getVendors(purpRestriction);
                const len = vendors.length;
                /**
 *
 *
 */
                let numEntries = 0;
                let startId = 0;
                let rangeField = '';
                for (let i = 0; i < len; i++) {
                    const vendorId = vendors[i];
                    if (startId === 0) {
                        numEntries++;
                        startId = vendorId;
                    }
                    /**
 *
 */
                    if (i === len - 1 || vendors[i + 1] > nextGvlVendor(vendorId, vendors[len - 1])) {
                        /**
 *
 *
 */
                        const isRange = !(vendorId === startId);
                        /*                           */
                        rangeField += BooleanEncoder.encode(isRange);
                        rangeField += IntEncoder.encode(startId, BitLength.vendorId);
                        if (isRange) {
                            rangeField += IntEncoder.encode(vendorId, BitLength.vendorId);
                        }
                        /*                                                   */
                        startId = 0;
                    }
                }
                /**
 *
 *
 */
                bitString += IntEncoder.encode(numEntries, BitLength.numEntries);
                bitString += rangeField;
            });
        }
        return bitString;
    }
    static decode(encodedString) {
        let index = 0;
        const vector = new PurposeRestrictionVector();
        const numRestrictions = IntEncoder.decode(encodedString.substr(index, BitLength.numRestrictions), BitLength.numRestrictions);
        index += BitLength.numRestrictions;
        for (let i = 0; i < numRestrictions; i++) {
            /*                  */
            const purposeId = IntEncoder.decode(encodedString.substr(index, BitLength.purposeId), BitLength.purposeId);
            index += BitLength.purposeId;
            /*                      */
            const restrictionType = IntEncoder.decode(encodedString.substr(index, BitLength.restrictionType), BitLength.restrictionType);
            index += BitLength.restrictionType;
            const purposeRestriction = new PurposeRestriction(purposeId, restrictionType);
            /*                              */
            const numEntries = IntEncoder.decode(encodedString.substr(index, BitLength.numEntries), BitLength.numEntries);
            index += BitLength.numEntries;
            for (let j = 0; j < numEntries; j++) {
                const isARange = BooleanEncoder.decode(encodedString.substr(index, BitLength.anyBoolean));
                index += BitLength.anyBoolean;
                const startOrOnlyVendorId = IntEncoder.decode(encodedString.substr(index, BitLength.vendorId), BitLength.vendorId);
                index += BitLength.vendorId;
                if (isARange) {
                    const endVendorId = IntEncoder.decode(encodedString.substr(index, BitLength.vendorId), BitLength.vendorId);
                    index += BitLength.vendorId;
                    if (endVendorId < startOrOnlyVendorId) {
                        throw new DecodingError(`Invalid RangeEntry: endVendorId ${endVendorId} is less than ${startOrOnlyVendorId}`);
                    }
                    for (let k = startOrOnlyVendorId; k <= endVendorId; k++) {
                        vector.add(k, purposeRestriction);
                    }
                }
                else {
                    vector.add(startOrOnlyVendorId, purposeRestriction);
                }
            }
        }
        vector.bitLength = index;
        return vector;
    }
}
